import React from "react";
import PropTypes from "prop-types";
import ReactGA from "react-ga";
import { Checkbox } from "@blueprintjs/core";
import styles from "../../../styles/FilterSection.module.scss";

class ReportTypeFilterSection extends React.Component {
  static propTypes = {
    tagType: PropTypes.string.isRequired,
    selected: PropTypes.array,
    onFilterChange: PropTypes.func.isRequired,
    isSingleInput: PropTypes.bool,
  };

  static defaultProps = {
    selected: [],
    isSingleInput: true,
  };

  handleReportTypeChange = (event) => {
    const isAdvanced = event.target.checked;

    const filter = {
      id: "report_type",
      type: this.props.tagType,
      displayName: isAdvanced ? "Advanced" : "Basic",
      value: isAdvanced,
      isSingleSelect: true,
    };

    ReactGA.event({
      category: "filter",
      action: "report_type_select",
      label: isAdvanced ? "advanced" : "basic",
    });

    this.props.onFilterChange(filter);
  };

  render() {
    const { selected } = this.props;
    const isAdvanced = selected.length > 0 ? selected[0].value : false;

    return (
      <div className={styles.radioFilterContainer}>
        <Checkbox
          checked={isAdvanced}
          onChange={this.handleReportTypeChange}
          className={styles.checkbox}
        />
      </div>
    );
  }
}

export default ReportTypeFilterSection;
